import { FLYBITS } from '../constants';
import { ANONYMOUS_SESSION } from '../reducers/authentication';
import { AUTHENTICATION_STATE, ISession, ISessionHolder } from '../types/authentication';
import axios from '../utils/axios';

export const login = async (email: string, password: string): Promise<ISession> => {
    const endpoint = FLYBITS.API_HOST + '/sso/auth/authenticate';
    let session;
    try {
        const response = (await axios.post(endpoint, {
            email,
            password
        }));
        if (200 === response.status) {
            session = {
                id: response.headers['x-authorization'],
                user: response.data,
            }
        }
    } catch (e) {/* tslint:disable:no-empty */}
    return session;
}

export const loginWithToken = async (accessToken: string): Promise<ISession> => {
    const endpoint = FLYBITS.PROXY_HOST + '/sso/auth/me';
    let session;
    try {
        const response = (await axios.get(endpoint, {
            headers: {
                Authorization: accessToken,
            },
            validateStatus: (status: number) => true,
        }));
        if (200 === response.status) {
            session = {
                id: accessToken,
                user: response.data,
            }
        }
    } catch (e) {/* tslint:disable:no-empty */}
    return session;
}

export const logout = async (): Promise<ISession> => {
    return ANONYMOUS_SESSION;
}

export const loadSession = (): ISessionHolder => ({
    session: ANONYMOUS_SESSION,
    state: AUTHENTICATION_STATE.LOGGED_OUT,
})



// WEBPACK FOOTER //
// ./src/services/authentication.ts